import {
  Dialog,
  DialogBackdrop,
  DialogPanel
} from "@headlessui/react";

interface NxtbnModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: any;
  size?: 'lg' | 'md' | 'sm' | 'xl' | 'xxl'; // Optional size prop
}

function NxtbnModal({ isOpen, onClose, children, size = 'md' }: NxtbnModalProps) {
  // Define the size mapping based on the size prop
  const sizeClasses = {
    sm: "w-full max-w-md",
    md: "w-full max-w-lg",
    lg: "w-full  max-w-2xl",
    xl: "w-full max-w-3xl",
    xxl: "w-full max-w-4xl",
  };

  return (
    <Dialog className="relative z-[110]" open={isOpen} onClose={onClose}>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className={`relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 ${sizeClasses[size]} data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
          >
            {children}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}

export default NxtbnModal;
